import { useState, useEffect } from 'react';
import { SkeletonEvent } from '../types.js';
import { NOOP } from '../Skeleton/helpers/index.js';

const useMFRender = ({ mfName, data = {}, skeleton, onRender = NOOP, onUnmount = NOOP, containerRef, }) => {
    const [mfInterface, setMfInterface] = useState();
    useEffect(() => {
        let canceled = false;
        if (!mfInterface && containerRef.current && skeleton) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            skeleton.initMF(mfName).then(mFinterface => {
                if (!canceled) {
                    setMfInterface(mFinterface);
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    skeleton.renderMF(mfName, containerRef.current, data);
                    onRender({
                        mfName,
                        data,
                    });
                }
            });
        }
        return () => {
            if (mfInterface) {
                try {
                    mfInterface.unmount({ mfName, element: containerRef.current });
                }
                catch (e) {
                    skeleton?.emitEvent(SkeletonEvent.MfUseruUnmountError, { mfName, error: e });
                }
                onUnmount({
                    mfName,
                    data,
                });
            }
            else {
                canceled = true;
            }
        };
        // We don't want to add data, because we don't want to force rerender of the entire MF each time the data change
    }, [skeleton, mfName, mfInterface, setMfInterface, containerRef]);
    useEffect(() => {
        if (mfInterface?.updateInitialData) {
            try {
                mfInterface.updateInitialData(data);
            }
            catch (e) {
                skeleton?.emitEvent(SkeletonEvent.MfUserUpdateInitialDataError, { mfName, error: e });
            }
        }
    }, [data, mfInterface]);
};

export { useMFRender as default };
